export enum AvailabilityStatus {
  Available = 'Available',
  Unavailable = 'Unavailable',
}
